import './Player.css'
import React, { PureComponent } from 'react'
import { AUDIO_PLAYING, AUDIO_PAUSED } from './enum'
import IconFont from 'components/iconfont/IconFont'
import { getThemeColor } from 'utils/utils'

export default class Player extends PureComponent {
    state = {
        modalVisible: false,
    }

    get playIcon() {
        const { playState } = this.props
        return AUDIO_PAUSED === playState ? 'play' : 'pause'
    }

    get themeColor() {
        const { theme } = this.props
        return getThemeColor(theme).default
    }

    handleModalOpen = () => {
        const { playState } = this.props
        if (AUDIO_PLAYING !== playState) {
            this.setState({ modalVisible: true })
        }
    }

    handleModalClose = () => {
        this.setState({ modalVisible: false })
    }

    handleBackwards = () => {
        const { playState, handleBackwards } = this.props
        if (AUDIO_PLAYING !== playState) {
            handleBackwards()
        }
    }

    render() {
        const { modalVisible } = this.state

        const {
            playState,
            points,
            sectionId,
            progress,
            handlePlay,
            handleSectionChange,
        } = this.props

        return (
            <div className='player-container'>
                {/* 播放的控制按钮 */}
                <div className='player-progress' style={{ width: progress, backgroundColor: this.themeColor }} />
                <span className='player-backwards' onClick={this.handleBackwards}>
                    <IconFont name='seek' size={40} color={this.themeColor} />
                </span>
                {
                    AUDIO_PLAYING === playState ?
                        <span className='player-loading'>
                            <IconFont name='loading' size={40} color={this.themeColor} />
                        </span>
                        :
                        <span className='player-play' onClick={handlePlay}>
                            <IconFont name={this.playIcon} size={40} color={this.themeColor} />
                        </span>
                }
                <span className='player-sections' onClick={this.handleModalOpen}>
                    <IconFont name='menu' size={40} color={this.themeColor} />
                </span>
                {/* 播放列表页 */}
                <div
                    className='player-list-modal'
                    onClick={this.handleModalClose}
                    style={{ height: modalVisible ? '' : '0%' }}
                >
                    <div className='player-list-holder' style={{ height: modalVisible ? '' : '0%' }} >
                        {
                            points.map((item, i, { length }) => {
                                const isActive = sectionId === item.id
                                return (
                                    <SectionItem
                                        key={item.id}
                                        item={item}
                                        isActive={isActive}
                                        theme={this.props.theme}
                                        handleSectionChange={handleSectionChange}
                                    />
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        )
    }
}

class SectionItem extends PureComponent {
    handleSectionChange = e => {
        const { item, handleSectionChange } = this.props
        handleSectionChange(item.id, item.duration)
        e.stopPropagation()
    }

    get indicatorStyle() {
        const { isActive } = this.props
        return {
            color: isActive ? this.themeColor.default : this.themeColor.light,
            borderBottomColor: this.themeColor.default,
            borderLeftColor: this.themeColor.default,
        }
    }

    get itemStyle() {
        const { isActive } = this.props
        return isActive ? 'player-list-item player-list-item-on' : 'player-list-item'
    }

    get themeColor() {
        const { theme } = this.props
        return getThemeColor(theme)
    }

    render() {
        const { item } = this.props

        return (
            <div
                key={item.id}
                className={this.itemStyle}
                style={this.indicatorStyle}
                onClick={this.handleSectionChange}
            >
                <div className='list-item-title'>{item.en}</div>
                <div className='list-item-title'>{item.cn}</div>
            </div>
        )
    }
}